import { useEffect, type FC } from 'react';
import { Navigate, Route, Routes, HashRouter } from 'react-router';
import { FaroRoutes } from '@grafana/faro-react';
import { QueryClientProvider } from '@tanstack/react-query';
import { routes } from '@/navigation/routes';
import { Layout } from './Layout';
import { GlobalToast } from './GlobalToast';
import { AuthProvider, RequireAuth } from '@/features/auth';
import { queryClient } from '@/shared/lib/queryClient';
import { useTelegramTheme } from '@/shared/telegram';

const AuthenticatedShell: FC = () => {
  const isDark = useTelegramTheme();

  useEffect(() => {
    document.documentElement.dataset.appearance = isDark ? 'dark' : 'light';
    return () => {
      delete document.documentElement.dataset.appearance;
    };
  }, [isDark]);

  return (
    <div className="app-root">
      <RequireAuth>
        <HashRouter>
          <FaroRoutes routesComponent={Routes}>
            <Route element={<Layout />}>
              {routes.map((route) => (
                <Route key={route.path} {...route} />
              ))}
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </FaroRoutes>
        </HashRouter>
        <GlobalToast />
      </RequireAuth>
    </div>
  );
};

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AuthenticatedShell />
      </AuthProvider>
    </QueryClientProvider>
  );
}
